import React from "react";
import { Hero, PageContent } from "../../components";

// TODO: Ne pas oublier les unitées + les titres :) (des %)
function SustainableDevelopment() {
  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col z-8">
      <Hero title={"Sustainable Development"}>
        Sustainable development is the pathway to the future we want {" "}
        <span className="text-lg font-black text-RougePastel md:text-xl lg:text-2xl">
          for all
        </span>{" "}
        societies
      </Hero>

      <PageContent>
        {`
As citizens and future engineers of a constantly evolving world, the
members of the Ionis-Paris 2023 team are, like the iGEM organization,
aware of the challenges of tomorrow's planet. In 2015, the **17
Sustainable Development Goals** (SDGs) were adopted by all United
Nations Member States to “promote prosperity while protecting the
planet”. These objectives, which represent an urgent call for action,
highlight that both **economic** and **social** development (including
education, health, social protection…) as well as **environmental**
sustainability are keys to solve today’s complex global problems. The
Ionis-Paris 2023 team places great importance on these values, which
is why the **Clean Heat** project was designed to best respond to several
of these SDGs.

## Good health and well-being

A global energy - and economic - crisis is currently plaguing the world.
As a result, many households suffer from the cold. This phenomenon
not only impacts the well-being of these individuals, but can also harm
their health in regions of the world with the coldest weather.

It is by allowing better access to households heating that Clean Heat
stands out as a means of promoting well-being and better health for
all. In addition, by participating in water depollution, the Clean Heat project helps limit the
exposure of individuals to EE2, an endocrine disruptor that can be a threat to health. It is
important for the team to complete the project while limiting its negative consequences, or
even creating a positive impact on well-being and health.

<div class="image_frame">
    <img class="illustration small" src="https://static.igem.wiki/teams/4577/wiki/human-practices/sustainable-dev/good-health-and-well-being.png">
</div>

## Quality education

As passionate students, it seemed essential to us to transmit our
knowledge and our ambitions to the engineering students of
tomorrow. Through our various interventions in schools and
associations as part of our education program, we had the opportunity
to educate children of all ages as well as young adults about
biotechnology. This was an opportunity for us to address notions such
as genetic material, microorganisms, the water cycle and its
pollution...

Thanks to the educators who welcomed us, we were able to build particularly stimulating
workshops to ensure that the principles taught were illustrated, and therefore remembered at
best. It has been a chance for us to raise awareness on these topics, but also to, why not,
inspire vocations to put synthetic biology at the service of the protection of our planet.

<div class="image_frame">
    <img class="illustration small" src="https://static.igem.wiki/teams/4577/wiki/human-practices/sustainable-dev/quality-education.png">
</div>

## Clean Water and sanitation

As future engineers and citizens of a blue planet, it seemed essential
to us to commit to the protection of this essential resource that is
water. One of the fundamental missions of Clean Heat therefore lies
in the depollution of water to make it a healthy living environment for
organisms, but also to allow safer consumption for humans.

Synthetic biology, when used wisely and with the right safety
measures, can make it possible to treat water in a cleaner way, but also more efficiently than
via traditional purification methods which have technical limitations in terms of no more
generating waste.

<div class="image_frame">
    <img class="illustration small" src="https://static.igem.wiki/teams/4577/wiki/human-practices/sustainable-dev/clean-water-and-sanitation.png">
</div>

## Affordable and clean energy

In the face of the dual energy and economic crisis and its significant
negative consequences across the world, the Clean Heat team
wanted to position itself as a clean heating solution while allowing
costs to be reduced compared to traditional heating systems.

Thanks to synthetic biology, the system developed is bio-based,
autonomous, and partly financed by the circular economy created by
the revaluation of certain waste (urine or water and biomass). This last element is particularly
linked to the use of micro-organisms, which naturally condition the composition of the recycled
materials and which thus avoid the addition of intermediate stages which could generate
additional costs or waste.

<div class="image_frame">
    <img class="illustration small" src="https://static.igem.wiki/teams/4577/wiki/human-practices/sustainable-dev/affordable-and-clean-energy.png">
</div>

## Sustainable cities and communities

Clean Heat aims to bring about a real change in household water
purification and energy consumption habits. However, profound
change is often driven by higher authorities or communities. The
Ionis-Paris 2023 team therefore surrounded itself with cities and
associations to understand the challenges of such changes for the
environment.

Many positive feedback indicates that the implementation of the Clean Heat system at the
scale of neighborhoods or cities would constitute an accelerator to make them more
sustainable, and create a significant change for the planet.

<div class="image_frame">
    <img class="illustration small" src="https://static.igem.wiki/teams/4577/wiki/human-practices/sustainable-dev/sustainablecities.png">
</div>

## Climate action

As a project aiming at reducing the impact of human activities
(whether linked to energy or water pollution), we are convinced that
it is thanks to this type of innovative initiatives that the climate crisis
will be able to be slowed down.

It is by creating a positive dynamic with coherent projects, also
involving a shift in mentalities thanks to new education and a circular
economy, that real change can happen. This is why iGEM is so powerful : teams are
encouraged to have a strong positive dynamic for the world !

<div class="image_frame">
    <img class="illustration small" src="https://static.igem.wiki/teams/4577/wiki/human-practices/sustainable-dev/climate-action.png">
</div>

## Life Below Water

Because water is an essential resource for life, but also because it is
home to a large number of living beings essential to biodiversity, it is
urgent to protect it.

This balance of life being threatened by pollution, Clean Heat offers
an innovative solution to preserve biodiversity, and thus our dear
planet in the long term.

<div class="image_frame">
    <img class="illustration small" src="https://static.igem.wiki/teams/4577/wiki/human-practices/sustainable-dev/life-below-water.png">
</div>

## Partnerships for the goals

During our iGEM experience, we had the chance to collaborate with
teams from all around the world on topics having high added value for
the environment and society. They brought a critical look at Clean
Heat to make our project better, and they inspired us to strengthen
our positive impact. This is the power of the iGEM community !

At the same time, Clean Heat received the support of scientists from
all domains, who shared their knowledge to enable us to make our project a real solution for
the planet.

<div class="image_frame">
    <img class="illustration small" src="https://static.igem.wiki/teams/4577/wiki/human-practices/sustainable-dev/partnerships-for-the-goals.png">
</div>

Finally, it was very important for the team to challenge the Clean Heat system by collaborating with a company, ClimatePartner, for the carbon footprint assessment. The calculations were carried out taking into account several elements:  
- Raw materials 
- Packaging 
- Upstream transport 
- Electricity 
- Downstream transpotation 
- End of life of materials 

**Per batch of 2500L, refilled every 48 hours, our system will emit 35 gCO2e/GJ with the effect of the heat pump.** 

For more information, please found the description here : [Carbon Footprint](https://static.igem.wiki/teams/4577/wiki/human-practices/sustainable-dev/carbon-footprint-assessment-climate-partner.pdf)

This initiative allows us to affirm that our project takes into account as many issues as possible to reduce its impact on the environment at all levels. To reduce even further our carbon footprint, we could optimize the use of the heat pump by only using it when needed, and decrease the electricity consumption of the photobioreactor.
        `}
      </PageContent>
    </div>
  );
}

export default SustainableDevelopment;
